/**
 * Analytics utility — typed wrappers around GA4 gtag events.
 * All events are fire-and-forget; errors are silently swallowed.
 */

declare global {
  interface Window {
    gtag?: (...args: any[]) => void
  }
}

function track(
  eventName: string,
  params?: Record<string, string | number | boolean>,
) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', eventName, params)
    }
  } catch {
    // Never throw from analytics
  }
}

// --- GPX / Import ---
export function trackGpxUploaded(params: {
  distance_km: number
  elevation_gain_m: number
  elevation_loss_m: number
  waypoint_count: number
}) {
  track('gpx_uploaded', params)
}

export function trackDemoLoaded() {
  track('demo_loaded')
}

export function trackPlanImported(success: boolean) {
  track('plan_imported', { success })
}

export function trackPlanExported(params: {
  segment_count: number
  distance_km: number
  elevation_gain_m: number
  total_time_hours: number
  pacing_model: string
  scenario: string
  has_nutrition_plan: boolean
  checkpoint_count: number
}) {
  track('plan_exported', params)
}

// --- Calibration ---
export function trackCalibrationCompleted(answers: Record<string, string>) {
  track('calibration_completed', answers)
}

// --- Navigation ---
export function trackTabViewed(tab: string) {
  track('tab_viewed', { tab })
}

// --- Course ---
export function trackCheckpointAdded(params: { distance_km: number }) {
  track('checkpoint_added', params)
}

// --- Pacing ---
export function trackPacingModelChanged(model_id: string) {
  track('pacing_model_changed', { model_id })
}

export function trackExecutionScenarioChanged(scenario: string) {
  track('execution_scenario_changed', { scenario })
}

// --- Nutrition ---
export function trackNutritionSegmentOpened(segment_index: number) {
  track('nutrition_segment_opened', { segment_index })
}

export function trackNutritionProductAdded(params: {
  product_id: string
  segment_id: string
}) {
  track('nutrition_product_added', params)
}
